import RefreshIcon from '@mui/icons-material/Refresh';
import { IconButton } from '@mui/material';
import { FC, MouseEventHandler } from 'react';
import { useStyles } from '../../../theme/styles.helpers';
import { RefreshButtonStyles } from './RefreshButton.Styles';

interface RefreshButtonProps {
  type?: 'button' | 'submit' | 'reset';
  className?: string;
  onClick?: MouseEventHandler<HTMLButtonElement>;
}

export const RefreshButton: FC<RefreshButtonProps> = ({ type, className, onClick }) => {
  const styles = useStyles(RefreshButtonStyles, {});

  return (
    <IconButton type={type} className={className} sx={styles.button} onClick={onClick}>
      <RefreshIcon />
    </IconButton>
  );
};
